webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {﻿

var angular = __webpack_require__(1);

__webpack_require__(2); // Copying objects is useful, but IE11/PhantomJS don't support ES6

//our modules
__webpack_require__(7);
__webpack_require__(22);
//require('../components/analytics');
__webpack_require__(24);
__webpack_require__(26);
__webpack_require__(31);
__webpack_require__(50);
__webpack_require__(54);
__webpack_require__(58);
__webpack_require__(62);

//third party modules
__webpack_require__(63);
//require('angular-animate');
__webpack_require__(65);
__webpack_require__(3);
__webpack_require__(67);
__webpack_require__(69);
__webpack_require__(70);
__webpack_require__(71);
//require('angulartics-piwik');
//require('angular-smart-table');
__webpack_require__(73);
__webpack_require__(75);
__webpack_require__(76);
//require('angulartics');
//require('angulartics-piwik');

//main app module for the application
angular.module('dpAdmin', [
    //'configure.configurationModule',
    'ui.router',
    'ngCookies',
    //'ngAnimate',
    'toaster',
    'ui.bootstrap',
    'environment',
    'ngSanitize',
    //'restangular',
    //'angulartics',
    //'angulartics.piwik',
    //'components.analyticsModule',
    'components.authenticationModule',
    'components.connectionsModule',
    'components.footerModule',
    'components.headerModule',
    'components.admin',
    'components.sessionModule',
    'components.authorizationModule',
    'components.uiElements.dropDownMenuModule'
    ])
    .config(['$stateProvider', '$httpProvider', '$urlRouterProvider', 'data_project_constants', 'envServiceProvider', 'RestangularProvider', function ($stateProvider, $httpProvider, $urlRouterProvider, data_project_constants, envServiceProvider) {

        //environmental configuration
        envServiceProvider.config({
            domains: {
                local:       ['dp-admin.exactbid.local', 'webpack-dp-admin.exactbid.local'],
                development: ['dev-dp-admin.exactbid.com'],
                staging:     ['stg-dp-admin.exactbid.com'],
                production:  ['dp-admin.exactbid.com']
            },
            vars: {
                local: {
                    api_authentication_endpoint: 'https://auth-dp-admin.exactbid.local/connect',
                    api_application_endpoint: 'https://api-dp-admin.exactbid.local/api/v1/',
                    reference_api_application_endpoint: 'https://api-reference.origin.exactbid.local/api/v1/',
                    award_api_application_endpoint: 'https://api.origin.exactbid.local/api/v1/',
                    auth_cookies_domain: '.exactbid.local',
                    analytics_domains: ['dp-admin.exactbid.local'],
                    analytics_url: '//piwik-dev.exactbid.com/',
                    //analytics_site_id: '11',
                    okta_issuer_url: 'https://lightbox-idp.oktapreview.com/oauth2/ausf3jaxas3VerhuE1d5', 
                    okta_redirect_url: 'https://webpack-dp-admin.exactbid.local:9089',
                    okta_client_id: '0oa2ikdm3IGwCxO5x1d6'
                },
                development: {
                    api_authentication_endpoint: 'https://auth-dev-dp-admin.exactbid.com/connect',
                    api_application_endpoint: 'https://api-dev-dp-admin.exactbid.com/api/v1/',
                    reference_api_application_endpoint: 'https://api-dev-reference.origin.exactbid.com/api/v1/',
                    award_api_application_endpoint: 'https://api-dev.origin.exactbid.com/api/v1/',
                    auth_cookies_domain: '.exactbid.com',
                    analytics_domains: ['dev-dp-admin.exactbid.com'],
                    analytics_url: '//piwik-dev.exactbid.com/',
                    //analytics_site_id: '12'
                    okta_issuer_url: 'https://lightbox-idp.oktapreview.com/oauth2/ausf3jaxas3VerhuE1d5', 
                    okta_redirect_url: 'https://dev-dp-admin.exactbid.com',
                    okta_client_id: '0oa2ikdm3IGwCxO5x1d6'
                },
                staging: {
                    api_authentication_endpoint: 'https://auth-stg-dp-admin.exactbid.com/connect',
                    api_application_endpoint: 'https://api-stg-dp-admin.exactbid.com/api/v1/',
                    award_api_application_endpoint: 'https://api-stg.origin.exactbid.com/api/v1/',
                    reference_api_application_endpoint: 'https://api-stg-reference.origin.exactbid.com/api/v1/',
                    auth_cookies_domain: '.exactbid.com',
                    analytics_domains: ['stg-dp-admin.exactbid.com'],
                    analytics_url: '//piwik-dev.exactbid.com/',
                    //analytics_site_id: '17'
                    okta_issuer_url: 'https://lightbox-idp.oktapreview.com/oauth2/ausf3jaxas3VerhuE1d5', 
                    okta_redirect_url: 'https://stg-dp-admin.exactbid.com',
                    okta_client_id: '0oa2ikdm3IGwCxO5x1d6'
                },
                production: {
                    api_authentication_endpoint: 'https://auth-dp-admin.exactbid.com/connect',
                    api_application_endpoint: 'https://api-dp-admin.exactbid.com/api/v1/',
                    reference_api_application_endpoint: 'https://api-reference.origin.exactbid.com/api/v1/',
                    award_api_application_endpoint: 'https://api.origin.exactbid.com/api/v1/',
                    auth_cookies_domain: '.exactbid.com',
                    analytics_domains: ['dp-admin.exactbid.com'],
                    analytics_url: '//stats.exactbid.com/',
                    //analytics_site_id: '6'
                    okta_issuer_url: 'https://lightbox-idp.okta.com/oauth2/ausz5xtoiY63iodFK4x6', 
                    okta_redirect_url: 'https://dp-admin.exactbid.com',
                    okta_client_id: '0oaz5yhx4AJomNMDQ4x6'
                }
            }
        });

        envServiceProvider.check();

        //default route for the application....may want to change this
        $urlRouterProvider.otherwise('/authentication/login');

        $stateProvider.state('home', {
            url: '',
            abstract: true,
            templateUrl: __webpack_require__(78)
        });

        $stateProvider.state('home.index', {
            url: '/index',
            authenticate: true,
            template: '<div>homeview</div>'
        });

        $httpProvider.interceptors.push(["$location", function ($location) {
            return {
                request: function (config) {
                    config.headers["RefererFullUrl"] = $location.absUrl();
                    return config;
                }
            };
        }]);
    }])
    .run(["$rootScope", "$state", "authenticationFactory", function ($rootScope, $state, authenticationFactory) {

        $rootScope.$state = $state;

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

            function loginRedirect() {
                $state.go('authentication.login');

                //prevent defaults stops events from doing anything so we can just redirect
                event.preventDefault();
            }

            if (!authenticationFactory.isBrowserCompatible(global)) {
                loginRedirect();
            }

            if (toState.name === "authentication.login") {
                return;
            }

            //these are set up in case the state does not have either a authenticate or a scope data member 
            var authenticateValue = toState.authenticate !== undefined ? toState.authenticate : false;

            //set up logic here for handling different roles and authentication
            if ((authenticateValue === true)) {
                authenticationFactory.oktaAuthClient.tokenManager.get('accessToken')
                    .then(function (token) {
                        if (token) {
                            console.log('Successfully retrieved Okta access token');
                        }
                        else {
                            loginRedirect();
                        }
                    })
                    .catch(function (error) {
                        console.error('Failed to retrieve Okta access token on state change: ' + error);
                        loginRedirect();
                    });
            }
        })
    }]);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * authentication Module
 * @module authenticationModule
 * @namespace components.authenticationModule
 */


angular.module('components.authenticationModule', [
    'components.connectionsModule',
    'ngCookies',
    'restangular',
    'ui.router'
])
.factory('authenticationFactory', __webpack_require__(8))
.factory('authenticationUIFactory', __webpack_require__(19))
.controller('logInController', __webpack_require__(20))
.config(['$stateProvider', function ($stateProvider) {

    $stateProvider.state('authentication', {
        url: '/authentication',
        abstract: true,
        templateUrl: __webpack_require__(21),
        data: {
            bodyCSS: 'login-body'
        }
    });

    $stateProvider.state('authentication.login', {
        url: '/login'
    });

    $stateProvider.state('authentication.logout', {
        url: '/logout'
    });
}]);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

var OktaAuth = __webpack_require__(9);

var queryString = __webpack_require__(13); // Convert JSON to URL-encoded string for token endpoint
var uuidV4 = __webpack_require__(16); // UUIDs for CSRF tokens

/**
* Factory for handling authentication and items around authentication
* @memberOf components.authenticationModule
* @namespace authenticationFactory
*/

authenticationFactory.$inject = ['Restangular', '$q', '$cookies', 'data_project_constants', 'envService'];

function authenticationFactory(Restangular, $q, $cookies, data_project_constants, envService) {
    var service = {};

    var authenticationCookiesDomain = envService.read('auth_cookies_domain');

    /* Okta Identity Authentication */
    service.oktaAuthClient = new OktaAuth({
        issuer: envService.read(data_project_constants.oktaConfig.issuerUrl),
        clientId: envService.read(data_project_constants.oktaConfig.clientId),
        redirectUri: envService.read(data_project_constants.oktaConfig.redirectUrl),
        pkce: true,
        tokenManager: {
            storage: 'localStorage',
            secure: true,
            storageKey: data_project_constants.cookies.okta_storage_key
        }
    });

    service.shouldHandleOktaCallback = service.oktaAuthClient.token.isLoginRedirect();

    service.authenticateWithOkta = function () {
        service.oktaAuthClient.token.getWithRedirect({
            responseType: ['token', 'id_token'],
            scopes: ['openid']
        })
            .catch(function (error) {
                console.error("Failed to redirect to Okta login: " + error);
            });
    };

    service.parseOktaTokens = function () {
        return service.oktaAuthClient.token.parseFromUrl();
    };

    // Retrieves and parson JSON string for idToken and access token written to local storage by OktaAuth client
    service.getOktaAuthenticationObject = function () {
        var oktaAuthStr = localStorage.getItem(data_project_constants.cookies.okta_storage_key);
        if (!oktaAuthStr) return;

        var oktaAuthObject = JSON.parse(oktaAuthStr);

        return {
            idToken: oktaAuthObject.idToken,
            accessToken: oktaAuthObject.accessToken
        }
    }

    /* Legacy Identity Server Authentication */
    var authConnection = Restangular.withConfig(function (config) {
        config.setBaseUrl(envService.read('api_authentication_endpoint'));
        config.setDefaultHeaders({
            'Accept': 'application/x-www-form-urlencoded',
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        // Restangular adds stuff to response objects, which we don't need for tokens.
        config.setPlainByDefault(true);
    });

    service.privateGetToken = function (postObject) {
        postObject = Object.assign(postObject, {
            client_id: 'dataportal',
            client_secret: 'dataportal'
        });

        return authConnection
            .all('token')
            .customPOST(queryString.stringify(postObject))
    };

    /**
    * Authenticate user
    * @method authenticate
    * @param {String} userName user name to check
    * @param {String} password password to check
    * @returns {Boolean} true if authenticated false if not
    * @memberOf components.authenticationModule.authenticationFactory
    */
    service.authenticate = function (userName, password) {
        var postObject = {
            grant_type: 'password',
            scope: 'offline_access dp_data use_csrf',
            username: userName,
            password: password
        };

        return service.privateGetToken(postObject).then(function (authObject) {
            $cookies.put(data_project_constants.cookies.csrf_name, uuidV4(), { secure: true, domain: authenticationCookiesDomain });
            service.setAuthenticationObject(authObject);
        });
    }

    /**
    * Refresh the authentication object
    * @method refreshAuthentication
    * @returns {Boolean} True if authentication object is refreshed, false if not
    * @memberOf components.authenticationModule.authenticationFactory
    */
    service.refreshAuthentication = function () {
        var auth = service.getAuthenticationObject();

        if (!auth) return $q.reject(false);

        var postObject = {
            grant_type: 'refresh_token',
            refresh_token: auth.refreshToken
        };

        return service.privateGetToken(postObject).then(function (authObject) {
            service.setAuthenticationObject(authObject);
        });
    }

    /**
    * Clear the authentication object
    * @method clearAuthentication
    * @returns {void}
    * @memberOf components.authenticationModule.authenticationFactory
    */
    service.clearAuthentication = function () {
        $cookies.remove(data_project_constants.cookies.csrf_name, { secure: true, domain: authenticationCookiesDomain });
        $cookies.remove(data_project_constants.cookies.user_name, { secure: true, domain: authenticationCookiesDomain });
    }

    /**
    * Sets the authentication object with the authentication and refresh values
    * @method setAuthenticationObject
    * @param {Object} authObject that will be used to refresh tokens and such
    * @memberOf components.authenticationModule.authenticationFactory
    */
    service.setAuthenticationObject = function (authObject) {
        $cookies.putObject(data_project_constants.cookies.user_name, authObject, { secure: true, domain: authenticationCookiesDomain });
    }

    /**
    * Gets the authentication object with the authentication and refresh values
    * @method getAuthenticationObject
    * @returns {Object} AuthenticationObject that will be used to refresh tokens and such
    * @memberOf components.authenticationModule.authenticationFactory
    */
    service.getAuthenticationObject = function () {
        var authCookie = $cookies.getObject(data_project_constants.cookies.user_name);
        if (!authCookie) return;

        return {
            refreshToken: authCookie.refresh_token,
            accessToken: authCookie.access_token
        };
    }

    /**
    * Checks if a browser is capable of using the library we use for generating unique strings for CSRF
    * @method isBrowserCompatible
    * @param {Object} globalObj the object to test for compatibility
    * @returns {Boolean} True if the browser is compatible with our app, false if not
    * @memberOf components.authenticationModule.authenticationFactory
    */
    service.isBrowserCompatible = function (globalObj) {
        var crypto = globalObj.crypto || globalObj.msCrypto;
        return !!(crypto && crypto.getRandomValues);
    }

    return service;
}

module.exports = authenticationFactory;


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Factory for handling authentication and items around authenticationUI
* @memberOf components.authenticationModule
* @namespace authenticationUIFactory
*/

function authenticationUIFactory() {

    //standard authentication factory link object
    function AuthLink(passedLink, passedName) {
        this.link = passedLink;
        this.title = passedName;
    }

    /**
    * Get user log out link
    * @method getLogOutLink
    * @param {String} passedUserLogOutLinkName text for the link
    * @returns {object} log out link object
    * @memberOf components.authenticationModule.authenticationUIFactory
    */
    function getLogOutLink(passedUserLogOutLinkName) {

        return new AuthLink('authentication.logout', passedUserLogOutLinkName);
    };

    /**
    * Get user log in link
    * @method getLogInLink
    * @param {String} passedUserLogInLinkName text for the link
    * @returns {object} log out link object
    * @memberOf components.authenticationModule.authenticationUIFactory
    */
    function getLogInLink(passedUserLogInLinkName) {

        return new AuthLink('authentication.login', passedUserLogInLinkName);
    };

    var service = {
        getLogOutLink: getLogOutLink,
        getLogInLink: getLogInLink
    };

    return service;
}

module.exports = authenticationUIFactory;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {﻿

/**
* Controller for the log in
* @memberOf components.authenticationModule
* @namespace logInController
*/

logInController.$inject = ['authenticationFactory', 'authorizationFactory', '$state', 'sessionManagementFactory', 'connectionsFactory', 'data_project_constants'];

function logInController(authenticationFactory, authorizationFactory, $state, sessionManagementFactory, connectionsFactory, data_project_constants) {
    /* jshint validthis:true */
    var vm = this;
    vm.oktaIdExistsInLegacyAccount = null;

    vm.isBrowserCompatible = authenticationFactory.isBrowserCompatible(global);

    vm.init = function () {
        if (authenticationFactory.oktaAuthClient.token.isLoginRedirect()) {
            authenticationFactory.parseOktaTokens()
                .then(function (result) {
                    authenticationFactory.oktaAuthClient.tokenManager.add('idToken', result.tokens.idToken);
                    authenticationFactory.oktaAuthClient.tokenManager.add('accessToken', result.tokens.accessToken);

                    vm.apiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.application_api);

                    vm.apiConnection
                        .all('userInfo/hasOktaIdentity')
                        .customGET()
                        .then(function (result) {
                            vm.oktaIdExistsInLegacyAccount = result.hasOktaIdentity;

                            if (vm.oktaIdExistsInLegacyAccount) {
                                authorizationFactory.setProfessorRole()
                                    .then(function () {
                                        // Directly assigning URL instead of moving to defined stateProvider.state 
                                        // as a workaround to remove Okta authentication response added to URL query string
                                        // Otherwise the query string persists and incorrectly shows the app as being in 
                                        // a callback state from Okta even though we have processed the auth response via parseOktaTokens()
                                        if (authorizationFactory.authorizeProfessor()) {
                                            window.location.assign('/#!/dataRights');
                                        }
                                        else {
                                            window.location.assign('/#!/admin');
                                        }
                                    })
                                    .catch(function (error) {
                                        console.error('Failed to retrieve roles for user: ', error);
                                    });
                            }
                        })
                        .catch(function (response) {
                            console.log('Failed to look up user Okta identity: ' + response);
                            vm.oktaIdExistsInLegacyAccount = false;
                        })
                })
                .catch(function (error) {
                    console.error("Failed to process Okta redirect response: " + error);
                });
        }
        else {
            authenticationFactory.authenticateWithOkta();
        }
    }

    vm.init();
}

module.exports = logInController;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/authentication/login-d5e5ba84.html";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * authorization Module
 * @module authorizationModule
 * @namespace components.authorizationModule
 */



angular.module('components.authorizationModule', [
    'components.connectionsModule',
    'ngCookies',
    'restangular'
])
.factory('authorizationFactory', __webpack_require__(23));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/** 
 * Factory for handling authorization of 
 * requests based on user roles
 * @namespace authorizationFactory
 */

authorizationFactory.$inject = ['$cookies', 'data_project_constants', 'connectionsFactory'];

function authorizationFactory($cookies, data_project_constants, connectionsFactory) {
    var service = {};

    var apiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.application_api);

    /**
    * Checks if user has the professor role 
    * @method authorizeProfessor
    * @returns {Boolean} isProfessor that tells if the user is a professor 
    * @memberOf components.authorizationModule.authorizationFactory
    */
    service.authorizeProfessor = function () {
        return $cookies.getObject(data_project_constants.cookies.user_is_professor_name);
    }

    service.setProfessorRole = function (isProfessor) {
        return apiConnection
                .all('userInfo/roles')
                .customGET()
                .then(function (result) {
                    var isProfessor = result.plain().isProfessor;

                    $cookies.putObject(data_project_constants.cookies.user_is_professor_name, isProfessor, { secure: true });
                });
    }

    return service;
}

module.exports = authorizationFactory;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * connections Module
 * @module connectionsModule
 * @namespace components.connectionsModule
 */


angular.module('components.connectionsModule', [
    'configure.configurationModule',
    'restangular',
    'ngCookies'
])
.factory('connectionsFactory', __webpack_require__(25));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Factory for interacting with the Restangular and Setting connections to outside services up
* @memberOf components.connectionsModule
* @namespace connectionsFactory
*/

connectionsFactory.$inject = ['$http', '$cookies', 'Restangular', 'authenticationFactory', 'envService', 'data_project_constants'];

function connectionsFactory($http, $cookies, Restangular, authenticationFactory, envService, data_project_constants) {
    var service = {};

    /**
    * Gets a connection for the values end point
    * @method getApplicationAPIConnection
    * @returns {Object:Restangular} end point for API values
    * @memberOf components.connectionsModule.connectionsFactory
    */
    service.getApplicationAPIConnection = function (applicationEndpoint) {
        return Restangular.withConfig(function (config) {
            config.setDefaultHttpFields({
                withCredentials: true
            });

            config.setBaseUrl(envService.read(applicationEndpoint));

            // Set up request handler here to pass on the api auth token
            config.addFullRequestInterceptor(function (element, operation, route, url, headers, params, httpConfig) {
                return {
                    headers: {
                        'Authorization': 'Bearer ' + authenticationFactory.getOktaAuthenticationObject().accessToken.value,
                        'HEADER-CSRF-TOKEN': $cookies.get(data_project_constants.cookies.csrf_name)
                    }
                };
            });
        });
    }

    return service;
}

module.exports = connectionsFactory;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * session Module
 * @module sessionModule
 * @namespace components.sessionModule
 */


angular.module('components.sessionModule', [
    'components.authenticationModule'
])
.factory('sessionManagementFactory', __webpack_require__(27))
.controller('sessionTimeOutWarningModalController', __webpack_require__(28))
.controller('sessionManagementController', __webpack_require__(29));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Factory for handling session management
* @memberOf components.sessionModule
* @namespace sessionManagementFactory
*/

sessionManagementFactory.$inject = ['$rootScope', '$timeout', '$q', 'authenticationFactory', 'data_project_constants'];

function sessionManagementFactory($rootScope, $timeout, $q, authenticationFactory, data_project_constants) {

    //constants for the subscription names
    var SESSION_START_SUB = data_project_constants.session_events.session_start;
    var SESSION_END_SUB = data_project_constants.session_events.session_end;
    var SESSION_WARNING_SUB = data_project_constants.session_events.session_warning;

    //constant for time length of session
    var TIME_END_LENGTH = data_project_constants.session_event_times.session_end;
    var TIME_WARNING_LENGTH = data_project_constants.session_event_times.session_warn;

    //timing based variables
    var timeStart;
    var endTime;
    var warningTime;

    //is the session currently started
    var sessionStarted = false;

    /**
    * Allow callers to use different events
    * @method sessionManagementEvents
    * @returns {SessionManagementSubscriptionType}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function sessionManagementEvents() {
        return {
            SessionStart: SESSION_START_SUB,
            SessionEnd: SESSION_END_SUB,
            SessionWarning: SESSION_WARNING_SUB
        }
    }

    /**
    * Helper method to manage subscriptions
    * @method subscribeToSessionManagementEvent
    * @param {String} passedSubscribeType subscription type to use
    * @param {Object} passedScope scope to use for notification
    * @param {Function} passedCallBack function to call 
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function subscribeToSessionManagementEvent(passedSubscribeType, passedScope, passedCallBack) {
        var subscribeHandler = $rootScope.$on(passedSubscribeType, passedCallBack);
        passedScope.$on('$destroy', subscribeHandler);
    }

    /**
    * This method starts the session and notifies subscribers
    * @method startSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function startSession() {
        //check if session is already started and call end session and then start it 
        if (!sessionStarted) {
            sessionStarted = true;
            timeSetUp();
            sessionStartNotify();
        }

    }

    /**
    * This method ends the session and notifies subscribers
    * @method isSessionStarted
    * @returns {Boolean} true is session is started false if not
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function isSessionStarted() {
        return sessionStarted;
    }

    /**
    * Renews the session timers
    * @method renewSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function renewSession() {

        var deferred = $q.defer();

        if (sessionStarted) {
            authenticationFactory.refreshAuthentication().then(function (resp) {
                deferred.resolve(true);
            },
            function (resp) {
                deferred.reject(false);
            });
            timeTearDown();
            timeSetUp();
        }
        else {
            //session is not started so there is no session to renew
            deferred.reject(false);
        }

        return deferred.promise;
    }

    /**
    * This method ends the session and notifies subscribers
    * @method endSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function endSession() {
        //check if session has started if not then do nothing
        if (sessionStarted) {
            sessionStarted = false;
            sessionEndNotify();
            timeTearDown();
            authenticationFactory.clearAuthentication();
        }
    }

    /**
    * Method that returns the difference between the start time and the current time
    * @method timeLeftInSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function timeLeftInSession() {
        //return delta between passed time and time left
        var currentDate = new Date();
        return currentDate - timeStart;
    }

    /**
    * Helper method that sends notification that the session has started to subscribers
    * @method sessionStartNotify
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function sessionStartNotify() {
        $rootScope.$emit(SESSION_START_SUB);
    }

    /**
    * Helper method that sends notification that the session has is entering warning stage to subscribers
    * @method sessionWarningNotify
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function sessionWarningNotify() {
        $rootScope.$emit(SESSION_WARNING_SUB);
    }

    /**
    * Helper method that sends notification that the session has ended to subscribers
    * @method sessionEndNotify
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function sessionEndNotify() {
        $rootScope.$emit(SESSION_END_SUB);
    }

    /**
    * Helper method sets up the timers and timeStart
    * @method timeSetUp
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function timeSetUp() {
        timeStart = new Date();
        warningTime = $timeout(sessionWarningNotify, TIME_WARNING_LENGTH);
        endTime = $timeout(endSession, TIME_END_LENGTH);
    }

    /**
    * Helper method tears down the timers and timeStart
    * @method timeSetUp
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementFactory
    */
    function timeTearDown() {
        timeStart = 0;
        $timeout.cancel(warningTime);
        $timeout.cancel(endTime);
    }

    var service = {
        sessionManagementEvents: sessionManagementEvents,
        subscribeToSessionManagementEvent: subscribeToSessionManagementEvent,
        startSession: startSession,
        endSession: endSession,
        renewSession: renewSession,
        timeLeftInSession: timeLeftInSession,
        isSessionStarted: isSessionStarted
    };

    return service;

}

module.exports = sessionManagementFactory;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Controller for the warning that the session management controller uses to warn people of an impending session end
* @memberOf components.sessionModule
* @namespace sessionTimeOutWarningModalController
*/

sessionTimeOutWarningModalController.$inject = ['$uibModalInstance', '$interval', 'data_project_constants'];

function sessionTimeOutWarningModalController($uibModalInstance, $interval, data_project_constants) {
    /* jshint validthis:true */
    var vm = this;
    vm.title = 'sessionTimeOutWarningModalController';
    vm.timeRemaining = data_project_constants.session_event_times.session_modal_count_down;
    vm.isAbleToStayLoggedIn = true;
    vm.timeDisplay = '';

    var dateTime = new Date();
    var intervalFunctionInstance = null;
    var INTERVAL_INCREMENT = 1000;
    var MINUTE_TO_MILLISECOND = 60000;
    var SECOND_TO_MILLISECOND = 1000;

    /**
    * Method to display a minute and second value based on passed in time
    * @method countDownDisplay
    * @param {time} passedInTime the time to display
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    vm.countDownDisplay = function (passedInTime) {
        var minutes = 0;
        var seconds = 0;

        //calculate new time
        minutes = Math.floor(passedInTime / MINUTE_TO_MILLISECOND);
        seconds = Math.floor((passedInTime % MINUTE_TO_MILLISECOND) / SECOND_TO_MILLISECOND);

        minutes = countDownDisplayFormatHelper(minutes);
        seconds = countDownDisplayFormatHelper(seconds);

        return minutes + ":" + seconds;
    }

    /**
    * Method to wrap the modal dismiss
    * @method logOut
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    vm.logOut = function () {

        intervalCancelHelper();
        $uibModalInstance.dismiss('logging out');
    }

    /**
    * Method to wrap the modal close
    * @method stayLoggedIn
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    vm.stayLoggedIn = function () {

        intervalCancelHelper();
        $uibModalInstance.close();
    }

    /**
    * Helper method to decrement the count down time
    * @method countDownTimer
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    function countDownTimer() {

        //check to see if timeRemaining is 0 and if so cancle timeout and return
        if (vm.timeRemaining <= 0) {
            vm.timeDisplay = vm.countDownDisplay(vm.timeRemaining);

            //ok we are done so stop the count down and disable the stay logged in button
            vm.isAbleToStayLoggedIn = false;
            intervalCancelHelper();
        }
        else {
            // call countDownDisplay and then blat result into the div on the modal
            vm.timeDisplay = vm.countDownDisplay(vm.timeRemaining);

            //decrement the timeRemaining number by a second
            vm.timeRemaining = vm.timeRemaining - INTERVAL_INCREMENT;
        }
    }

    /**
    * Helper method to display the time intervals correctly
    * @method countDownDisplayFormatHelper
    * @returns {passedNumber}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    function countDownDisplayFormatHelper(passedNumber) {
        passedNumber = passedNumber <= 9 ? '0' + passedNumber : passedNumber;
        passedNumber = passedNumber <= 0 ? '00' : passedNumber;

        return passedNumber
    }

    /**
    * Helper method to clean up the $interval function if there is one running
    * @method intervalCancelHelper
    * @returns {Void}
    * @memberOf components.sessionModule.sessionTimeOutWarningModalController
    */
    function intervalCancelHelper() {
        if (intervalFunctionInstance != null || intervalFunctionInstance != undefined) {
            $interval.cancel(intervalFunctionInstance);
        }
    }

    //controller actions here
    vm.timeDisplay = vm.countDownDisplay(vm.timeRemaining);
    intervalFunctionInstance = $interval(countDownTimer, INTERVAL_INCREMENT);
}

module.exports = sessionTimeOutWarningModalController;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Controller for session management
* @memberOf components.sessionModule
* @namespace sessionManagementController
*/

sessionManagementController.$inject = ['sessionManagementFactory', '$uibModal', '$scope', '$state', '$timeout', 'data_project_constants', 'toaster'];

function sessionManagementController(sessionManagementFactory, $uibModal, $scope, $state, $timeout, data_project_constants, toaster) {
    /* jshint validthis:true */
    var vm = this;
    vm.title = 'sessionManagementController';
    vm.countdownTimeSpan;
    vm.initModal;
    vm.isSessionStarted = false;
    vm.currentSessionRenewalRetryCount = 0;
    vm.sessionLastChecked = 0;

    var SESSION_RENEWAL_WAIT = data_project_constants.session_event_times.session_refresh_delay;
    var NUMBER_OF_RETRIES = data_project_constants.session_management.number_of_connection_retries;
    var TOAST_TIME_OUT = data_project_constants.session_management.session_toast_visible_timespan;
    var SESSION_RESTORE_WAIT_INTERVAL = data_project_constants.session_management.session_restore_interval;

    var sessionRenewalTime = Date.now();

    /**
    * Init the timeout warning modal
    * @method initModal
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    vm.initModal = function () {
        var modal = $uibModal.open({

            templateUrl: __webpack_require__(30),
            controller: 'sessionTimeOutWarningModalController as sessionTimeOutWarning'

        }).result.then(function (resultItem) {
            vm.renewSession();
        }, function () {
            vm.countdownTimeSpan = 0;
            $state.go('authentication.logout');
        });
    }

    /**
    * Renew the session with the session manager
    * @method renewSession
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    vm.renewSession = function () {

        if (vm.isSessionStarted && sessionRenewalCheck()) {
            refreshSessionRetry(NUMBER_OF_RETRIES);
        }
    }

    //register for events
    sessionManagementFactory.subscribeToSessionManagementEvent(sessionManagementFactory.sessionManagementEvents().SessionStart, $scope, sessionStartHandler);
    sessionManagementFactory.subscribeToSessionManagementEvent(sessionManagementFactory.sessionManagementEvents().SessionWarning, $scope, sessionWarningHandler);
    sessionManagementFactory.subscribeToSessionManagementEvent(sessionManagementFactory.sessionManagementEvents().SessionEnd, $scope, sessionEndHandler);

    /**
    * Helper method that handles the session start event from the session manager
    * @method sessionStartHandler
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    function sessionStartHandler() {
        vm.isSessionStarted = true
    }

    /**
    * Helper method that handles the session warning event from the session manager
    * @method sessionWarningHandler
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    function sessionWarningHandler() {
        vm.countdownTimeSpan = sessionManagementFactory.timeLeftInSession() / 1000;
        vm.initModal();
    }

    /**
    * Helper method that handles the session end event from the session manager
    * @method sessionEndHandler
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    function sessionEndHandler() {
        vm.isSessionStarted = false;
    }

    /**
    * Helper method to make sure that we are only banging on the session factory every SESSION_RENEWAL_WAIT number of seconds
    * @method sessionRenewalCheck
    * @returns {Boolean} true if we can call the session factory and false if we cannot
    * @memberOf components.sessionModule.sessionManagementController
    */
    function sessionRenewalCheck() {
        //create new date on the calling of this function
        vm.sessionLastChecked = Date.now();

        if ((vm.sessionLastChecked >= sessionRenewalTime) && (vm.currentSessionRenewalRetryCount == 0)) {
            sessionRenewalTime = new Date(Date.now() + SESSION_RENEWAL_WAIT);
            return true;
        }
        else {
            return false;
        }
    }

    /**
    * Helper method to retry refreshing the authentication object 
    * @method refreshSessionRetry
    * @param {int} passedMaxRetries number of times to retry to connect
    * @returns {Void}
    * @memberOf components.sessionModule.sessionManagementController
    */
    function refreshSessionRetry(passedMaxRetries) {
        sessionManagementFactory.renewSession().then(function () {

            //we only need to show the connection restored if there was an issue in the first place
            if (passedMaxRetries < NUMBER_OF_RETRIES) {
                toaster.pop({
                    type: 'success',
                    title: 'Connection Restored',
                    body: "{ template: 'angular/components/uielements/notifications/successNotification.html', data: 'Connection has been restored'}",
                    bodyOutputType: 'templateWithData',
                    showCloseButton: true,
                    timeout: TOAST_TIME_OUT
                });

                vm.currentSessionRenewalRetryCount = 0;
            }

        }, function () {

            if (passedMaxRetries > 0) {

                toaster.pop({
                    type: 'error',
                    title: 'Connection Lost',
                    body: "{ template: 'angular/components/uielements/notifications/errorNotification.html', data: 'Trying to restore connection number of retries left: " + passedMaxRetries + "'}",
                    bodyOutputType: 'templateWithData',
                    showCloseButton: true,
                    timeout: TOAST_TIME_OUT
                });

                passedMaxRetries = --passedMaxRetries;
                vm.currentSessionRenewalRetryCount = NUMBER_OF_RETRIES - passedMaxRetries;

                $timeout(function () { refreshSessionRetry(passedMaxRetries) }, SESSION_RESTORE_WAIT_INTERVAL);
            }
            else if (passedMaxRetries == 0) {
                toaster.pop({
                    type: 'error',
                    title: 'Connection Lost',
                    body: "{ template: 'angular/components/uielements/notifications/errorNotification.html', data: 'We are sorry but we are unable to reestablish connection'}",
                    bodyOutputType: 'templateWithData',
                    showCloseButton: true,
                    timeout: 0
                });

                //end the session here
                vm.isSessionStarted = false;
            }

        });
    }
}

module.exports = sessionManagementController;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/session/sessionTimeOutWarningModal-987e860c.html";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Admin
 * @module admin
 * @namespace components.admin
 */


angular.module('components.admin', ['restangular', 'ui.router', 'ui.select', 'ngTagsInput'])
.controller('adminController', __webpack_require__(32))
.controller('dataRightsController', __webpack_require__(33))
.directive('ebAccountDropdown', __webpack_require__(34))
.directive('ebDropdown', __webpack_require__(36))
.directive('ebCheckboxes', __webpack_require__(38))
.directive('ebQueryDefaults', __webpack_require__(40))
.directive('ebStatusToggle', __webpack_require__(42))
.directive('ebTextField', __webpack_require__(44))
.directive('ebReadOnlyField', __webpack_require__(46))

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('home.admin', {
        url: '/admin',
        authenticate: true,
        templateUrl: __webpack_require__(48)
    });

    $stateProvider.state('home.dataRights', {
        url: '/dataRights',
        templateUrl: __webpack_require__(49)
    });
}]).run(["$templateCache", function ($templateCache) {
    // In order to override the ui.select template for multiple drop downs we have to replace the
    // match-multiple.tpl.html with our own original located at...
    // <YourPathToDataProject>\RIMSDataProjectUI\src\ExactBid.DataProject.UI\node_modules\ui-select\src\bootstrap\match-multiple.tpl.html

    // Removed the selected item (btn-primary) class addition in ng-class on third nested span
    var ebMatchMultipleTemplate = '<span class="ui-select-match">' +
        '<span ng-repeat="$item in $select.selected track by $index">' +
        '<span class="ui-select-match-item btn btn-default btn-xs" tabindex="-1" type="button" ng-disabled="$select.disabled" ng-click="$selectMultiple.activeMatchIndex = $index;" ng-class="{\'select-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected">' +
        '<span class="close ui-select-match-close" ng-hide="$select.disabled" ng-click="$selectMultiple.removeChoice($index)">&nbsp;&times;</span><span uis-transclude-append></span>' +
        '</span>' +
        '</span>' +
        '</span>'

    $templateCache.put('bootstrap/match-multiple.tpl.html', ebMatchMultipleTemplate);
}]);


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2); // Copying objects is useful, but IE11/PhantomJS don't support ES6

/**
* Controller for user & company administration
* @memberOf components.admin
* @namespace adminController
*/

adminController.$inject = ['connectionsFactory', '$state', 'data_project_constants', '$q']

function adminController(connectionsFactory, $state, data_project_constants, $q) {
    var vm = this;

    vm.handleCheckboxCheck = function (event, key, storageObj) {
        storageObj[key] = event.target.checked;
    }

    vm.convertToTitleCase = function (camelCaseStr) {
        return camelCaseStr.replace(/([A-Z])/g, function (match) { return " " + match; })
            .replace(/^./, function (match) { return match.toUpperCase(); }).trim();
    }

    vm.convertToCamelCase = function (titleCaseStr) {
        var camelCaseStr = "";
        titleCaseStr.trim().replace(/\s+/g, ' ').split(' ').forEach(function (word) { camelCaseStr += word[0].toUpperCase() + word.slice(1); });
        return camelCaseStr[0].toLowerCase() + camelCaseStr.slice(1);
    }

    vm.setPermissionsCheckboxes = function (permissionsCheckboxesObj, accountPermissionsObj) {
        if (!permissionsCheckboxesObj || !accountPermissionsObj) return;

        var modules = Object.keys(accountPermissionsObj);
        for (var i = 0; i < modules.length; i++) {
            var modulePermissions = accountPermissionsObj[modules[i]];
            permissionsCheckboxesObj["Download"] = typeof modulePermissions["ExcelDownload"] !== 'undefined' ? modulePermissions["ExcelDownload"] : permissionsCheckboxesObj["Download"];
            permissionsCheckboxesObj[vm.convertToTitleCase(modules[i])] = modulePermissions["DataView"];
        }
    }

    vm.setQueryDefaultsTextboxes = function (queryDefaultsTextboxesObj, accountQueryDefaultsObj) {
        queryDefaultsTextboxesObj.states = null;
        queryDefaultsTextboxesObj.propertyType = null;
        if (!accountQueryDefaultsObj || !accountQueryDefaultsObj.filters) return;
        if (!accountQueryDefaultsObj.filters.location || !accountQueryDefaultsObj.filters.location) return;
        var queryDefaultsObj = JSON.parse(JSON.stringify(accountQueryDefaultsObj));
        queryDefaultsTextboxesObj.states = queryDefaultsObj.filters.location.states;
        queryDefaultsTextboxesObj.propertyType = queryDefaultsObj.filters.property.propTypeM;
    }

    vm.readPermissionsCheckboxesBeforePUTorPOST = function (permissionsCheckboxesObj, accountPermissionsObj) {
        if (!permissionsCheckboxesObj || !accountPermissionsObj) return;

        var modules = Object.keys(permissionsCheckboxesObj);
        for (var i = 0; i < modules.length; i++) {
            var moduleKey = vm.convertToCamelCase(modules[i]);
            if (!accountPermissionsObj[moduleKey]) continue;
            accountPermissionsObj[moduleKey]["DataView"] = permissionsCheckboxesObj[modules[i]];
            if (typeof accountPermissionsObj[moduleKey]["ExcelDownload"] !== 'undefined') accountPermissionsObj[moduleKey]["ExcelDownload"] = permissionsCheckboxesObj["Download"];
        }
    }

    vm.readQueryDefaultsTextboxesBeforePUTorPOST = function (queryDefaultsTextboxesObj, accountQueryDefaultsObj) {
        if (!accountQueryDefaultsObj) accountQueryDefaultsObj = { filters: {} };
        accountQueryDefaultsObj.filters.location = { states: null };
        accountQueryDefaultsObj.filters.property = { propTypeM: null };
        if (!queryDefaultsTextboxesObj) return;
        var textboxesObj = JSON.parse(JSON.stringify(queryDefaultsTextboxesObj));
        accountQueryDefaultsObj.filters.location.states = textboxesObj.states;
        accountQueryDefaultsObj.filters.property.propTypeM = textboxesObj.propertyType;
    }

    vm.getBaseAccount = function (labelProperty, accounts) {
        var selector = {};
        if (labelProperty == "name") selector = { name: "<base-company>" };
        if (labelProperty == "username") selector = { username: "<base-user>" };
        var baseAccount = _.find(accounts, selector);
        return baseAccount ? baseAccount : {};
    }

    vm.apiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.application_api);
    vm.referenceApiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.reference_api);
    vm.awardApiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.award_api);

    // TODO(breilly, 2018-08-10): I don't love this. Creating a class like this makes it feel like it should be a
    // controller, which means it could be a directive instead. But since the contents of the UI differs between users
    // and companies, we'd have to create a transcluded controller. That would force us to do something like...
    //
    // <acct-mgr ...>
    //   <h1>{{$parent.accountType}} Management</h1>
    // </acct-mgr>
    //
    // Notice the use of $parent to access the directive's controller (this is the correct and necessary syntax). Not
    // a big fan of that either. Hopefully as time goes on it'll become more clear how best to handle this shared code
    // and UI.
    //
    // In the meantime, I don't want to abstract too early; see...
    // https://www.sandimetz.com/blog/2016/1/20/the-wrong-abstraction
    vm.createAccountManager = function (accountType) {
        var manager = {
            accounts: [],
            permissionsCheckboxes: {},
            queryDefaultsTextboxes: {}
        };

        manager.getAccountList = function () {
            return vm.apiConnection.all(accountType).customGET('')
                .then(function (response) {
                    manager.accounts = response.plain()[accountType];
                })
                .then(function () {
                    // NOTE(breilly, 2018-10-08): Only users use the create mode at the moment, but that'll change
                    // soon, so I don't mind letting that spill into the shared code right now.
                    if (!manager.createMode) {
                        manager.onSelectAccount();
                    }
                });
        };

        manager.onSelectAccount = function () {
            manager.editedAccount = null;
            manager.status = null;

            if (!manager.selectedId) return;

            var matchingAccount = _.find(manager.accounts, { id: manager.selectedId });

            if (!matchingAccount) return;

            vm.setPermissionsCheckboxes(manager.permissionsCheckboxes, matchingAccount.permissions);
            if (accountType == 'companies') vm.setQueryDefaultsTextboxes(manager.queryDefaultsTextboxes, matchingAccount.queryDefaults);

            manager.editedAccount = Object.assign({}, matchingAccount);
        };

        manager.toggleField = function (fieldName) {
            manager.editedAccount[fieldName] = !manager.editedAccount[fieldName];
        };

        manager.setStatus = function (isProcessing, isError, message) {
            manager.status = {
                isProcessing: isProcessing,
                isError: isError,
                message: message
            };
        };

        manager.omitNonUpdatableAccountFields = function(account) {
            var modifiedAccount;

            if (accountType == 'users') {
                modifiedAccount = _.omit(account, ['dateCreated', 'origin.dateStatusChanged', 'vision.dateStatusChanged']);
            }
            else if (accountType == 'companies') {
                modifiedAccount = _.omit(account, ['dateCreated', 'origin.dateStatusChanged', 'vision.dateStatusChanged', 'vision.restrictions']);
            }

            return modifiedAccount;
        }

        manager.update = function () {
            manager.setStatus(true, false, 'Processing...');

            if (manager.editedAccount) vm.readPermissionsCheckboxesBeforePUTorPOST(manager.permissionsCheckboxes, manager.editedAccount.permissions);
            if (manager.editedAccount && accountType == 'companies') vm.readQueryDefaultsTextboxesBeforePUTorPOST(manager.queryDefaultsTextboxes, manager.editedAccount.queryDefaults);

            var deferred = $q.defer();

            vm.apiConnection
                .one(accountType, manager.selectedId)
                .customPUT(manager.omitNonUpdatableAccountFields(manager.editedAccount), undefined, undefined, { 'Content-Type': 'application/json' })
                .then(function (data) {
                    manager.getAccountList()
                        .then(function () {
                            manager.setStatus(false, false, 'Update succeeded');

                            deferred.resolve();
                        },
                        function (result) {
                            // No longer authorized (probably because you disabled yourself or your company)
                            if (result.status == 401) {
                                $state.go('authentication.logout');
                                return;
                            }
                        });
                },
                function (result) {
                    if (result.status == 401) {
                        $state.go('authentication.logout');
                        return;
                    }

                    manager.getAccountList().then(function () {
                        manager.setStatus(false, true, 'Updated failed: ' + result.data.message);
                    });
                });

            return deferred.promise;
        };

        manager.createAccountSkeleton = function (labelProperty, baseAccount) {
            var skeletons = {
                "username": {
                    isEnabled: true,
                    vision: { status: "Inactive" },
                    origin: { status: "Inactive" },
                    permissions: baseAccount.permissions,
                    queryDefaults: baseAccount.queryDefaults ? baseAccount.queryDefaults : { filters: { location: { states: [] }, property: { propTypeM: null } } }
                },
                "name": {
                    isEnabled: true,
                    vision: {
                        status: 'Inactive',
                        billing: 'Subscription'
                    },
                    origin: {
                        status: 'Inactive',
                        billing: 'Subscription',
                        customerType: 'Market',
                        reportType: 'Market'
                    },
                    permissions: baseAccount.permissions,
                    queryDefaults: baseAccount.queryDefaults ? baseAccount.queryDefaults : { filters: { location: { states: [] }, property: { propTypeM: null } } }
                }
            };
            return skeletons[labelProperty];
        };

        manager.enableCreateMode = function () {
            if (manager.createMode) return;

            manager.createMode = true;
            manager.selectedId = -1;
            manager.status = null;

            var baseAccount = vm.getBaseAccount(manager.labelProperty, manager.accounts);

            manager.editedAccount = manager.createAccountSkeleton(manager.labelProperty, baseAccount);

            vm.setPermissionsCheckboxes(manager.permissionsCheckboxes, baseAccount.permissions);
            vm.setQueryDefaultsTextboxes(manager.queryDefaultsTextboxes, baseAccount.queryDefaults);
        };

        manager.disableCreateMode = function () {
            if (!manager.createMode) return;

            manager.createMode = false;
            manager.selectedId = null;
            manager.editedAccount = null;
        };

        manager.create = function () {
            manager.setStatus(true, false, 'Processing...');

            if (manager.editedAccount) vm.readPermissionsCheckboxesBeforePUTorPOST(manager.permissionsCheckboxes, manager.editedAccount.permissions);
            if (manager.editedAccount && accountType == 'companies') vm.readQueryDefaultsTextboxesBeforePUTorPOST(manager.queryDefaultsTextboxes, manager.editedAccount.queryDefaults);

            var deferred = $q.defer();

            vm.apiConnection
                .all(accountType)
                .customPOST(manager.editedAccount, undefined, undefined, { 'Content-Type': 'application/json' })
                .then(function (data) {
                    manager.getAccountList()
                        .then(function () {
                            manager.setStatus(false, false, 'Create \'' + manager.editedAccount[manager.labelProperty] + '\' succeeded');
                            manager.disableCreateMode();
                            manager.selectedId = data.id;

                            deferred.resolve();
                        },
                        function (result) {
                            // No longer authorized (probably because you disabled yourself or your company)
                            if (result.status == 401) {
                                $state.go('authentication.logout');
                                return;
                            }
                        });
                },
                function (result) {
                    if (result.status == 401) {
                        $state.go('authentication.logout');
                        return;
                    }

                    manager.setStatus(false, true, 'Create failed: ' + result.data.message);
                });

            return deferred.promise;
        };

        manager.init = function () {
            manager.getAccountList();
            manager.selectedId = null;
            manager.queryDefaultsTextboxes = {
                propertyType: null,
                states: null
            };
        };

        return manager;
    };

    vm.getResource = function (resource) {
        return vm.apiConnection
            .all(resource)
            .customGET()
            .then(function (result) {
                vm[resource] = result.plain()[resource];
            });
    };

    vm.getReferenceResource = function (resource) {
        if (vm.referenceResources === undefined) vm.referenceResources = {};
        return vm.referenceApiConnection
            .all(resource)
            .customGET()
            .then(function (result) {
                vm.referenceResources[resource] = result.plain()[resource];
            });
    }

    vm.resetOktaIdInputField = function () {
        vm.userManager.editedAccount.oktaId = "";
    }

    vm.configureUserManager = function () {
        vm.userManager = vm.createAccountManager('users');
        vm.userManager.labelProperty = 'username';

        var originalOnSelectAccount = vm.userManager.onSelectAccount;

        vm.userManager.onSelectAccount = function () {
            originalOnSelectAccount();

            if (!vm.userManager.selectedId) return;

            var matchingAccount = vm.userManager.accounts.find(function (x) { return x.id == vm.userManager.selectedId; });

            if (!matchingAccount || !matchingAccount.defaultPerformanceMonitorQueryId) return;  //_.find(vm.userManager.accounts, { id: vm.userManager.selectedId });

            // There is a default report for each module but the default values for state / propTypeM 
            // should be the same for all because the were created with the same values and saved reports cannot currently be updated 
            // So we are just loading the values from the default Performance Monitor report
            vm.awardApiConnection
                .all('savedreports/' + matchingAccount.defaultPerformanceMonitorQueryId)
                .customGET()
                .then(function (defaultQuery) {
                    vm.setQueryDefaultsTextboxes(vm.userManager.queryDefaultsTextboxes, defaultQuery.savedReport.queryParameters);
                });
        }

        var originalCreate = vm.userManager.create;

        vm.userManager.create = function () {
            originalCreate().then(function () {
                var defaultParameters = { filters: { location: { states: null }, property: { propTypeM: null } } };
                vm.readQueryDefaultsTextboxesBeforePUTorPOST(vm.userManager.queryDefaultsTextboxes, defaultParameters);

                vm.awardApiConnection
                    .all('savedreports/default/' + vm.userManager.selectedId, undefined, undefined, { 'Content-Type': 'application/json' })
                    .customPUT(defaultParameters)
                    .then(function (response) {
                        vm.userManager.getAccountList().then(function () {
                            vm.userManager.setStatus(false, false, 'Create user default reports succeeded');
                            vm.userManager.disableCreateMode();
                        },
                            function (result) {
                                // No longer authorized (probably because you disabled yourself or your company)
                                if (result.status == 401) {
                                    $state.go('authentication.logout');
                                    return;
                                }
                            });
                    }),
                    function (result) {
                        vm.userManager.getAccountList().then(function () {
                            vm.userManager.setStatus(false, true, 'Updated failed: ' + result.data.message);
                        });
                    };
            });
        }

        var originalUpdate = vm.userManager.update;

        vm.userManager.update = function () {
            originalUpdate().then(function () {
                var defaultParameters = { filters: { location: { states: null }, property: { propTypeM: null } } };
                vm.readQueryDefaultsTextboxesBeforePUTorPOST(vm.userManager.queryDefaultsTextboxes, defaultParameters);

                vm.awardApiConnection
                    .all('savedreports/default/' + vm.userManager.selectedId, undefined, undefined, { 'Content-Type': 'application/json' })
                    .customPUT(defaultParameters)
                    .then(function (response) {
                        vm.userManager.getAccountList().then(function () {
                            vm.userManager.setStatus(false, false, 'Update user default reports succeeded');
                        },
                            function (result) {
                                // No longer authorized (probably because you disabled yourself or your company)
                                if (result.status == 401) {
                                    $state.go('authentication.logout');
                                    return;
                                }
                            });
                    }),
                    function (result) {
                        vm.userManager.getAccountList().then(function () {
                            vm.userManager.setStatus(false, true, 'Updated failed: ' + result.data.message);
                        });
                    };
            });
        }

        vm.userManager.init();
    }

    vm.configureCompanyManager = function () {
        vm.companyManager = vm.createAccountManager('companies');
        vm.companyManager.labelProperty = 'name';

        // TODO(jjones, 2018-08-29): Come up with a better way to handle the differences and similarities between users and companies.
        var originalOnSelectAccount = vm.companyManager.onSelectAccount;

        vm.companyManager.onSelectAccount = function () {
            originalOnSelectAccount();

            // Handle the resetting of the display lenders then add any lenders that the company may have in their Origin restrictions.
            vm.displayLenders = vm.lenders;

            var restrictions = vm.companyManager.editedAccount ? vm.companyManager.editedAccount.origin.restrictions : null;

            if (restrictions && restrictions.lenders.length) {
                var knownLenderIds = _.map(vm.lenders, 'id');
                var unknownLenderIds = _.difference(restrictions.lenders, knownLenderIds);

                var unknownLenders = unknownLenderIds.map(function (id) {
                    return { id: id, name: 'unknown lender: ' + id };
                });

                vm.displayLenders = vm.displayLenders.concat(unknownLenders);
            }
        }

        var originalCompanyUpdate = vm.companyManager.update;

        // TODO(jjones, 2018-09-06): Come up with a better way to handle this
        vm.companyManager.update = function () {
            var reportType = vm.companyManager.editedAccount.origin.reportType;

            if (reportType != 'Lender') {
                vm.companyManager.editedAccount.origin.restrictions.lenders = [];
            }

            if (reportType != 'Vendor') {
                vm.companyManager.editedAccount.origin.restrictions.vendorAddresses = [];
                vm.companyManager.editedAccount.origin.restrictions.vendorDomains = [];
            }

            originalCompanyUpdate();
        }

        var originalCompanyCreate = vm.companyManager.create;

        vm.companyManager.create = function () {
            originalCompanyCreate().then(function () {
                vm.companyManager.selectedId = null;
            });
        }

        vm.companyManager.init();
    }

    vm.$onInit = function () {
        
        vm.configureUserManager();
        vm.configureCompanyManager();        

        vm.getResource('statuses');
        vm.getResource('billingTypes');
        vm.getResource('customerTypes');
        vm.getResource('reportTypes');
        vm.getResource('lenders').then(function () {
            vm.displaylenders = vm.lenders
        });
        vm.getReferenceResource('states');
        vm.getReferenceResource('propertyTypes').then(function () {
            vm.referenceResources.propertyTypes.unshift({ id: null, name: "Select a Property Types" });
        });
    };
}

module.exports = adminController;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/** 
 * Controller for data rights configuration 
 * @memberOf components.dataRights
 * @namespace dataRightsController
 */

dataRightsController.$inject = ['connectionsFactory', 'data_project_constants'];

function dataRightsController(connectionsFactory, data_project_constants) {
    var vm = this;

    vm.apiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.application_api);
    vm.dataRightsConnection = vm.apiConnection.all('dataRights');

    vm.updateState = {
        status: '',
        isError: false
    };

    vm.dataRights = [];

    vm.resetUpdateState = function () {
        vm.updateState.status = '';
        vm.updateState.isError = false;
    }

    vm.onDataRightsClick = function (clickedConfig) {
        vm.resetUpdateState();

        clickedConfig.dataRights = !clickedConfig.dataRights;
        clickedConfig.dataRightsModified = !clickedConfig.dataRightsModified;
    };

    vm.onReviewedClick = function (clickedConfig) {
        vm.resetUpdateState();

        clickedConfig.needsReview = !clickedConfig.needsReview;
        clickedConfig.reviewed = !clickedConfig.reviewed;
    }

    vm.getModifiedDataRights = function (dataRights) {
        return dataRights.filter(function (element) {
            return element.dataRightsModified || element.reviewed;
        }).map(function (element) {

            if (element.reviewed) {
                if (element.status == 'New' || element.status == 'Returning' || element.status == 'Active') {
                    element.status = 'Active';
                }
            }

            return _.omit(element, ['dataRightsModified', 'reviewed']);
        })
    };

    vm.updateDataRights = function () {

        var modifiedDataRights = vm.getModifiedDataRights(vm.dataRights);

        if (modifiedDataRights.length > 0) {
            vm.dataRightsConnection
                .customPOST(modifiedDataRights, undefined, undefined, { 'Content-Type': 'application/json' })
                .then(function (data) {
                    if (data.requestCount == data.modifiedCount) {
                        vm.updateState.status = "Update Succeeded!";
                        vm.updateState.isError = false;

                        vm.resetModifedAndReviewed();
                    }
                    else {
                        vm.updateState.status = "Error updating...";
                        vm.updateState.isError = true;
                    } 
                },
                function (result) {
                    vm.updateState.status = "Error updating...";
                    vm.updateState.isError = true;
                });
        }
    };

    vm.resetModifedAndReviewed = function () {
        vm.dataRights.forEach(function (element) {
            element.reviewed = false;
            element.dataRightsModified = false;
        });
    }

    vm.$onInit = function () {
        vm.dataRightsConnection
            .customGET()
            .then(function (result) {
                var dataRights = result.plain().dataRights.filter(function (obj) {
                    return obj.status !== 'Retired';
                });

                dataRights.forEach(function (element) {
                    element.dataRightsModified = false;
                    element.reviewed = false; 
                });

                vm.dataRights = dataRights;
            });
    };
}

module.exports = dataRightsController;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ebAccountDropdown.$inject = [];

function ebAccountDropdown() {
    return {
        restrict: 'E',
        templateUrl: __webpack_require__(35),
        scope: {
            plural: '@',
            singular: '@',
            labelProp: '@',
            manager: '='
        }
    };
}

module.exports = ebAccountDropdown;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/directives/ebAccountDropdown-2055831e.html";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ebDropdown.$inject = [];

function ebDropdown() {
    return {
        restrict: 'E',
        templateUrl: __webpack_require__(37),
        scope: {
            required: '=',
            for: '@',
            label: '@',
            model: '=',
            options: '=',
            selectProp: '@',
            labelProp: '@'
        }
    };
}

module.exports = ebDropdown;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/directives/ebDropdown-fce7ca4e.html";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ebCheckboxes.$inject = [];

function ebCheckboxes() {
    return {
        restrict: 'E',
        templateUrl: __webpack_require__(39),
        scope: {
            title: '@',
            storageObj: '=',
            handler: '='
        }
    };
}

module.exports = ebCheckboxes;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/directives/ebCheckboxes-ec59107e.html";

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ebQueryDefaults.$inject = [];

function ebQueryDefaults() {
    return {
        restrict: 'E',
        templateUrl: __webpack_require__(41),
        scope: {
            sourceObj: '=',
            storageObj: '='
        }
    };
}

module.exports = ebQueryDefaults;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/directives/ebQueryDefaults-165bef4b.html";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ebStatusToggle.$inject = [];

function ebStatusToggle() {
    return {
        restrict: 'E',
        templateUrl: __webpack_require__(43),
        scope: {
            for: '@',
            label: '@',
            model: '=',
            trueText: '@',
            trueClass: '@',
            falseText: '@',
            falseClass: '@',
            toggle: '&onToggle'
        }
    };
}

module.exports = ebStatusToggle;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/directives/ebStatusToggle-8058342d.html";

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ebTextField.$inject = [];

function ebTextField() {
    return {
        restrict: 'E',
        templateUrl: __webpack_require__(45),
        scope: {
            required: '=',
            for: '@',
            label: '@',
            placeholder: '@',
            model: '='
        }
    };
}

module.exports = ebTextField;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/directives/ebTextField-1ef26baa.html";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ebReadOnlyField.$inject = [];

function ebReadOnlyField() {
    return {
        restrict: 'E',
        templateUrl: __webpack_require__(47),
        scope: {
            for: '@',
            label: '@',
            placeholder: '@',
            model: '='
        }
    };
}

module.exports = ebReadOnlyField;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/directives/ebReadOnlyField-d7a1782f.html";

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/admin/admin-7fff7aef.html";

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/admin/dataRights-75a3124b.html";

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * footer Module
 * @module footerModule
 * @namespace components.footerModule
 */


angular.module('components.footerModule', [])
.controller('footerController', __webpack_require__(51))
.directive('ebFooter', __webpack_require__(52));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
 * Controller for the footer
 * @memberOf components.footerModule
 * @namespace footerController
 */

footerController.$inject = ['$location'];

function footerController($location) {
    /* jshint validthis:true */
    var vm = this;
    vm.title = 'footerController';

    vm.currentDate = new Date();

    /**
    * Gets current date
    * @method getCurrentDate
    * @returns {Object} current date object
    * @memberOf components.footerModule.footerController
    */
    vm.getCurrentDate = function () { return vm.currentDate; };
}

module.exports = footerController;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Directive for the footer
* @memberOf components.footerModule
* @namespace ebFooter
*/
ebFooter.$inject = ['$window'];

function ebFooter($window) {
    // Usage: <ebFooter></ebFooter>

    var directive = {
        restrict: 'E',
        scope: false,
        templateUrl: __webpack_require__(53),
        controller: 'footerController'
    };
    return directive;
}

module.exports = ebFooter;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/footer/ebFooter-6a32364f.html";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * header Module
 * @module headerModule
 * @namespace components.headerModule
 */


angular.module('components.headerModule', [])
.controller('headerController', __webpack_require__(55))
.directive('ebHeader', __webpack_require__(56));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Controller for the header
* @memberOf components.headerModule
* @namespace headerController
*/

headerController.$inject = ['sessionManagementFactory', 'authorizationFactory'];

function headerController(sessionManagementFactory, authorizationFactory) {
    /* jshint validthis:true */
    var vm = this;
    vm.title = 'headerController';

    vm.currentDate = new Date();

    /**
   * Gets current date
   * @method getCurrentDate
   * @returns {Object} current date object
   * @memberOf components.headerModule.headerController
   */
    vm.getCurrentDate = function () { return vm.currentDate; };

    vm.adminViews = new Object();
    vm.adminViews.menuItemTitle = "Views";
    vm.adminViews.menuItemId = "navigationLinks";
    vm.adminViews.menuItemList = [];
    vm.adminViews.menuItemList.push({ title: 'Admin', link: 'home.admin' });
    vm.adminViews.menuItemList.push({ title: 'Data Rights', link: 'home.dataRights' });

    vm.isProfessor = authorizationFactory.authorizeProfessor();

    if (!sessionManagementFactory.isSessionStarted()) {
        sessionManagementFactory.startSession();
    }
}

module.exports = headerController;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Directive for the header
* @memberOf components.headerModule
* @namespace ebHeader
*/

ebHeader.$inject = ['$window'];

function ebHeader($window) {
    // Usage: <ebHeader></ebHeader>

    var directive = {
        restrict: 'E',
        scope: false,
        templateUrl: __webpack_require__(57),
        controller: 'headerController',
        controllerAs: 'header'
    };
    return directive;
}


module.exports = ebHeader;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/header/ebHeader-92e6198c.html";

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿/**
 * drop down menu Module
 * @module dropDownMenuModule
 * @namespace components.uiElements.dropDownMenuModule
 */


angular.module('components.uiElements.dropDownMenuModule', [])
.controller('dropDownController', __webpack_require__(59))
.directive('ebBasicDropDownMenu', __webpack_require__(60));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Controller for the drop down menu
* @memberOf components.uiElements.dropDownMenuModule
* @namespace dropDownController
*/

dropDownController.$inject = ['$location'];

function dropDownController($location) {
    /* jshint validthis:true */
    var vm = this;
}

module.exports = dropDownController;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
﻿

/**
* Directive for the drop down menu
* @memberOf components.uiElements.dropDownMenuModule
* @namespace ebBasicDropDownMenu
*/

ebBasicDropDownMenu.$inject = ['$window'];

function ebBasicDropDownMenu($window) {
    // Usage: <ebBasicDropDownMenu></ebBasicDropDownMenu>

    var directive = {
        restrict: 'E',
        templateUrl: __webpack_require__(61),
        scope: {
            menuItemList: "=",
            menuItemTitle: "=",
            menuItemId: "=",
            displayMenu: "="
        }
    };
    return directive;
}

module.exports = ebBasicDropDownMenu;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/components/dropdownmenu/ebBasicDropDownMenu-50bde32b.html";

/***/ }),
/* 62 */
/***/ (function(module, exports) {

﻿angular.module('configure.configurationModule', [])
.constant('data_project_constants',
{
    'api_authentication_scopes': {
        'data_query': 'data:query',
        'user_edit': 'user:edit',
        'user_add': 'user:add',
        'user_remove': 'user:remove'
    },
    'session_management': {
        'number_of_connection_retries': 3,
        'session_restore_interval': 2000,
        'session_toast_visible_timespan': 6000
    },
    'session_events': {
        'session_start': 'sessionManagementFactory:start',
        'session_warning': 'sessionManagementFactory:warning',
        'session_end': 'sessionManagementFactory:end'
    },
    'session_event_times': {
        // 13:30 minutes until we show the session warning
        'session_warn': 13.5 * (60 * 1000),
        'session_modal_count_down': 1 * (60 * 1000),
        'session_refresh_delay': 1 * (60 * 1000),
        // 14:30 minutes then we end the session for the user
        // the reason for this is that the refresh token on the auth server
        // has an idle timeout of 15 minutes so this gives us a buffer of 
        // 30 seconds so that we don't get into the trouble of having the 
        // auth time out before the UI times out
        'session_end': 14.5 * (60 * 1000)
    },
    'cookies': {
        'csrf_name': 'CSRF-TOKEN',
        'user_name': 'DpAdminAuthorization',
        'user_is_professor_name': 'UserRole-Professor',
        'okta_storage_key': 'okta-token-storage'
    },
    'oktaConfig': {
        'clientId': 'okta_client_id',
        'issuerUrl': 'okta_issuer_url',
        'redirectUrl': 'okta_redirect_url'
    },
    'endpoints': {
        'application_api': 'api_application_endpoint',
        'reference_api': 'reference_api_application_endpoint',
        'award_api': 'award_api_application_endpoint'
    }
});


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "angular/app/layout-home-5ef17a28.html";

/***/ })
],[4]);


// WEBPACK FOOTER //
// app-6bc4d663.min.js